// extracted by mini-css-extract-plugin
export default {"modal":"app-documents-FolderRenameModal-FolderRenameModal-module__mxBWP1SeSdmnHY2am80B","field":"app-documents-FolderRenameModal-FolderRenameModal-module__kY5EeQZjhlpqkFQ5ADiR"};